import { createAction } from 'redux-actions';
import { Actions } from '../constants';

export const setUserIdentifier = createAction(Actions.SET_USER_IDENTIFIER);
export const defineExperiment = createAction(Actions.DEFINE_EXPERIMENT);
export const selectVariant = createAction(Actions.SELECT_VARIANT);
